
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.5 0h-18C9.307 0 8.162.506 7.318 1.406A4.967 4.967 0 006 4.8v38.4c0 1.273.474 2.494 1.318 3.394.844.9 1.989 1.406 3.182 1.406h27c1.194 0 2.338-.506 3.182-1.406A4.967 4.967 0 0042 43.2V12L28.5 0z","fill":"#F63220"}}),_c('path',{attrs:{"d":"M28.5 0v10a2 2 0 002 2H42","fill":"#F99"}}),_c('path',{attrs:{"d":"M13.5 24.54h3.63c.888 0 1.58.228 2.074.684.495.448.743 1.08.743 1.896 0 .816-.248 1.452-.743 1.908-.495.456-1.186.684-2.074.684h-2.11V33H13.5v-8.46zm3.441 3.984c1.045 0 1.568-.464 1.568-1.392 0-.472-.13-.82-.389-1.044-.26-.232-.652-.348-1.179-.348h-1.92v2.784h1.92zM21.28 24.54h3.065c1.359 0 2.412.372 3.158 1.116.755.736 1.132 1.772 1.132 3.108s-.377 2.376-1.132 3.12c-.746.744-1.799 1.116-3.158 1.116H21.28v-8.46zm2.97 7.2c1.91 0 2.864-.992 2.864-2.976 0-1.976-.954-2.964-2.864-2.964H22.8v5.94h1.45zM30.166 24.54h5.445v1.236h-3.948v2.304h3.712v1.236h-3.712V33h-1.497v-8.46z","fill":"#fff"}})])
          )
        }
      }
    